/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IRailway {
  /** Список ID направлений **/
  directionIds?: TRailway_DirectionIds;
  /** Расстояние до станции **/
  distance?: TRailway_Distance;
  /** ID ЖД-станции **/
  id?: TRailway_Id;
  /** Название станции **/
  name?: TRailway_Name;
  /** Время до станции **/
  time?: TRailway_Time;
  /** Способ передвижения до ЖД **/
  travelType?: TRailway_TravelType;
}

export type TRailway_DirectionIds = null | number[];

export type TRailway_Distance = null | TRailway_Distance_1;

export type TRailway_Distance_1 = string | number;

export type TRailway_Id = null | number;

export type TRailway_Name = null | string;

export type TRailway_Time = null | number;

export type TRailway_TravelType = null | ETravelType;

export enum ETravelType {
  /** На машине **/
  ByCar = 'byCar',
  /** Пешком **/
  ByFoot = 'byFoot',
}
